import { BaseEnum } from './baseEnum';

const listSystemModuleTypeEnum: Array<SystemModuleType> = [];

export class SystemModuleType extends BaseEnum {
  static None = new SystemModuleType(0, 'NONE', 'Nenhum', 'award');
  static WorforcePlan = new SystemModuleType(1, 'WFP', 'Orgânico ideal', 'award');
  static Vacation = new SystemModuleType(2, 'VACATION', 'Férias', 'award');
  static PointTimeHandling = new SystemModuleType(3, 'POINT_TIME_HANDLING', 'Ponto', 'award');
  static Benefit = new SystemModuleType(4, 'BENEFIT', 'benefício', 'award');
  static WCK = new SystemModuleType(5, 'WCK', 'Rotinas Técnicas', 'clipboard');
  static PROBATIONARY_PERIOD = new SystemModuleType(
    6,
    'PROBATIONARY_PERIOD',
    'Périodo de Experiência',
    'calendar'
  );
  static ETHICS_CHANNEL = new SystemModuleType(6, 'ETHICS_CHANNEL', 'Canal de Ética', 'message-circle');

  constructor(
    public id: number,
    public value: string,
    public label: string,
    public icon: string
  ) {
    super(id, value, label, icon);

    listSystemModuleTypeEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listSystemModuleTypeEnum;
  }
}
